/*
 * The chatbot's opening comment and suggestion pills for step-by-step advice.
 *
 * Every step gets the SAME placeholder, on purpose. In v1 the front end
 * populates the first "response" and the pills, and the business rules that will
 * vary them per step — and key them off the user's actual numbers — are a
 * separate story. Until that lands, guessing per-step copy here would put words
 * in the agent's mouth that nobody has signed off on, so there is one default
 * question and one default pill pair.
 *
 * The design does specify real copy for two steps (monthly retirement income:
 * "Is this an amount that you can live on during retirement?", and summary: "Is
 * there anything you want to change before accepting this recommendation?", with
 * matching pills). That belongs to the business-rules story, not here.
 */

export const DEFAULT_COMMENT = 'Would you like to learn more?'
export const DEFAULT_SUGGESTIONS = ['Yes', 'No']

// One place for the business-rules story to make this per-step.
export const stepChatDefaults = () => ({
  comment: DEFAULT_COMMENT,
  suggestions: DEFAULT_SUGGESTIONS,
})

// Names the step's chat in the main Hey Nic Recents list, which the SBSA chats
// also land in. Without it the first pill tap would title the chat "Yes".
export const stepChatTitle = stepLabel =>
  stepLabel ? `Step-by-step advice: ${stepLabel}` : 'Step-by-step advice'
